import type { Radio } from '../radio/radio.types';
import type { Range } from './form-content.range.types';
import type { Search as SearchProps } from '../search/search.types';
import type { CheckboxList } from './form-content.checkbox-list.types';

export enum ContentKeys {
  Radio = 'radio',
  Range = 'range',
  Checkbox = 'checkbox',
}

export type SearchItem = { key: string; label: string };

export type Search = {
  searchKeys: string[];
  searchDataset: SearchItem[];
  searchInput: SearchProps;
  searchTerm?: (arg: string) => void;
  searchResult?: (arg: SearchItem[]) => void;
};

type RadioListBase = {
  key: ContentKeys.Radio;
  categories: {
    header?: string;
    options: Radio[];
    id: string;
  }[];
  setSelectedValue?: (id: string, value: string) => void;
};

type RadioListSearch = RadioListBase & {
  searchProps: Search;
};

export type RadioList = RadioListBase | RadioListSearch;

type FormContentBase = {
  closeLabel: string;
  isOpen?: boolean;
  close?: () => void;
  onSubmit?: () => void;
  submitLabel: string;
  title: string;
};

export type FormContentDropdownList = FormContentBase & {
  content: RadioList;
};

export type FormContentFilter = FormContentBase & {
  content: Range | CheckboxList | RadioList;
};

export type FormContent = FormContentDropdownList | FormContentFilter;
